module.exports = __webpack_public_path__ + "Step1_Header_new.9e954406.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/desktop/headers/Step1_Header_new.png
// module id = EHNb
// module chunks = 0